import { IQuoteBehavior } from "./IQuoteBehavior";

export interface IQuoteBehaviorSpecifiable {
  quoteBehavior: IQuoteBehavior;
}

export function instanceOfIQuoteBehaviorSpecifiable(instance: any): instance is IQuoteBehaviorSpecifiable {
  return instance
    && (instance.quoteBehavior !== undefined);
}
